import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pb-[20px] pt-[15px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0d2e 30%, #0d0818 60%, #0a0a0a 100%)'
  }} data-id="element-225">
      {/* Logo */}
      <div className="mb-4" data-id="element-226">
        <span className="text-[#A855F7] text-xl sm:text-2xl font-black tracking-widest" data-id="element-227">
          💪 VÉRTICE DIGITAL™
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-228">
        Todo tu año de Pilates.
        <br data-id="element-229" />
        <span className="text-[#A855F7]" data-id="element-230">Listo. Desde hoy.</span>
      </h1>

      {/* Quote */}

      {/* Mockup image — LCP element, priority load con dimensiones explícitas */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-sm mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-231">
        <img src="https://cdn.magicpatterns.com/uploads/31u5QJSeu9DcZZvu9dCom1/Sin_titulo_(420_x_420_px)_(13).png" alt="VÉRTICE DIGITAL MegaPack Pilates Listo — Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-232" />
      </div>

      {/* Subtitle */}
      <p className="text-[#A855F7] sm:text-2xl font-bold max-w-3xl mb-[0px] text-[16px]" data-id="element-233">
        El sistema N°1 para instructores de Pilates — Todos los niveles
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-234">
        Clases + protocolos + planificaciones + negocio listos para usar. Sin
        improvisar. Sin planificar domingos. Sin perder alumnos.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-[10px] gap-[3px] sm:gap-[5px] items-center justify-center mx-auto" data-id="element-235">
        <span className="bg-black/50 border border-[#A855F7]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-236">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-[#A855F7]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-237">
          ⚡ Acceso en 5 min
        </span>
        <span className="bg-black/50 border border-[#A855F7]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-238">
          📚 Todos los niveles
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-purple-pulse bg-[#A855F7] font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#C084FC] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm mt-4 text-[#FFFFFF]" data-id="element-239">
        💪 → QUIERO MI MEGAPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-240">
        <span data-id="element-241">🛡️ Garantía 7 días</span>
        <span data-id="element-242">🔒 Pago seguro</span>
        <span data-id="element-243">💳 Mercado Pago </span>
      </p>
    </section>;
}